import { SortDirection } from '../enums';

export interface Sort {
  columnKey: number | string;
  direction: SortDirection;
}

export function sortArrayBySortConfig<T extends Record<string, any>>(array: T[], sortConfig: Sort): T[] {
  let property = '';

  if (typeof sortConfig.columnKey === 'number') {
    const keys = Object.keys(array[0] || {});
    property = keys[sortConfig.columnKey];
  }

  if (typeof sortConfig.columnKey === 'string') {
    property = sortConfig.columnKey;
  }

  if (!property) {
    throw new Error('Invalid property');
  }

  const getNestedValue = (obj: Record<string, any> | any, path: string) => {
    return path.split('.').reduce((acc, part) => (acc ? acc[part] : undefined), obj);
  };

  return array.sort((a, b) => {
    let valA = getNestedValue(a, property);
    let valB = getNestedValue(b, property);

    //Both null or undefined
    if ((valA === null || valA === undefined) && (valB === null || valB === undefined)) return 0;
    //Only a null or undefined
    if (valA === null || valA === undefined) return sortConfig.direction === SortDirection.Ascending ? 1 : -1;
    //Only b null or undefined
    if (valB === null || valB === undefined) return sortConfig.direction === SortDirection.Ascending ? -1 : 1;

    //Case insensitive sorting
    if (typeof valA === 'string') {
      valA = valA.toLowerCase();
    }

    if (typeof valB === 'string') {
      valB = valB.toLowerCase();
    }

    if (valA < valB) return sortConfig.direction === SortDirection.Ascending ? -1 : 1;
    if (valA > valB) return sortConfig.direction === SortDirection.Ascending ? 1 : -1;
    return 0;
  });
}
